import React, { useState, FC } from "react";
import { Button } from "@UI/Components/Button/Button";
import { Icon } from "@UI/Components/Icon/Icon";
import messages from "./messages";
import { EuroCircle } from "@UI/Components/Icons/EuroCircle";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import { Box } from "@UI/Components/Box/Box";
import { ResponsiveModal } from "@UI/Components/ResponsiveModal/ResponsiveModal";
import { Stack } from "@UI/Components/Stack/Stack";
import { Rate } from "@Shared/Components/Rate/Rate";
import { Text } from "@UI/Components/Text/Text";
import { ServiceOfferPreview } from "../../ServiceOfferPreview/ServiceOfferPreview";
import { IServiceOffer } from "../../../services/serviceOffers";

interface Props {
  serviceOffer: IServiceOffer;
}

export const CalculationModalWithToggle: FC<Props> = ({ serviceOffer }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const isAcceptedVisitOffer =
    serviceOffer?.state === "accepted" && serviceOffer.rateType === "estimate";

  return (
    <Stack
      direction={isAcceptedVisitOffer ? "column" : "row"}
      justifyContent={isAcceptedVisitOffer ? "center" : "space-between"}
      pl="2"
      pb="3"
    >
      <Text
        fontWeight="bold"
        color="gray.800"
        fontSize={isAcceptedVisitOffer ? "lg !important" : "initial"}
        textAlign={isAcceptedVisitOffer ? "center" : "left"}
      >
        {isAcceptedVisitOffer ? (
          <>
            <FormattedMessage {...messages.visit} />{" "}
            <FormattedMessage {...messages.forQuote} />
          </>
        ) : (
          <FormattedMessage
            {...messages.offer}
            values={{
              offer: (
                <Box textAlign="right" as="span">
                  <Rate
                    unit={serviceOffer.billingUnit}
                    cents={serviceOffer.rateCents}
                    currency={serviceOffer.rateCurrency}
                  />
                </Box>
              ),
            }}
          />
        )}
      </Text>
      <Button
        fontSize="sm"
        variant="link"
        color="gray.700"
        onClick={handleToggle}
        display="flex"
        as="span"
        cursor="pointer"
        alignItems="center"
        _hover={{
          background: "none",
        }}
      >
        <Icon as={EuroCircle} marginRight="1" />
        <FormattedMessage {...messages.viewPriceEstimate} />
      </Button>
      <ResponsiveModal onClose={handleToggle} isOpen={isOpen}>
        <Box paddingBottom="4">
          <ServiceOfferPreview
            serviceOfferId={serviceOffer?.id}
            showServiceFees={false}
          />
        </Box>
      </ResponsiveModal>
    </Stack>
  );
};
